import { Injectable, inject } from '@angular/core';
import {
  FeaturesCollection,
  IFeature,
  PermissionGroup,
} from '@principle-theorem/feature-flags';
import {
  IOrganisationService,
  ORGANISATION_SERVICE,
} from '@principle-theorem/ng-shared';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { INgFeatureFlagsConfig, NG_FEATURE_FLAGS_CONFIG } from './config';

@Injectable()
export class FeatureFlagsService {
  features: FeaturesCollection;
  config: INgFeatureFlagsConfig = inject(NG_FEATURE_FLAGS_CONFIG);
  organisation: IOrganisationService = inject(ORGANISATION_SERVICE);

  constructor() {
    this.features = new FeaturesCollection(
      this.config.features,
      this.config.production
    );
  }

  isFeatureEnabled$(feature: IFeature): Observable<boolean> {
    return (this.organisation.optInFeatures$ ?? of([])).pipe(
      map((optInFeatures) =>
        this.features.isFeatureEnabled(feature, optInFeatures)
      )
    );
  }

  isFeatureEnabledByLabel$(label: string): Observable<boolean> {
    return (this.organisation.optInFeatures$ ?? of([])).pipe(
      map((optInFeatures) =>
        this.features.isFeatureEnabledByLabel(label, optInFeatures)
      )
    );
  }

  getFeaturePermissions$(): Observable<PermissionGroup[]> {
    return (this.organisation.optInFeatures$ ?? of([])).pipe(
      map((optInFeatures) => this.features.getFeaturePermissions(optInFeatures))
    );
  }
}
